import { apiGet } from '../../interceptors';

export const FinanceService = {
  async fetchListKassa() {
    const response = await apiGet('/listkassa');

    return response.data && response.data.kassa ? response.data.kassa : [];
  }
};
